/**
 * @generated SignedSource<<6bff24bf352264588f0fe14b7a45d8e9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedCreatorTopContent_itemSearch$data = {
  readonly browseContent: {
    readonly title?: string | null;
  } | null;
  readonly relatedCreators: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly linkData: {
          readonly " $fragmentSpreads": FragmentRefs<"SeoLink_linkData">;
        };
        readonly title: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"SaveSearchButton_itemSearch" | "SbRespContentModuleSelector_itemSearch">;
  readonly " $fragmentType": "SbSharedCreatorTopContent_itemSearch";
};
export type SbSharedCreatorTopContent_itemSearch$key = {
  readonly " $data"?: SbSharedCreatorTopContent_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedCreatorTopContent_itemSearch">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedCreatorTopContent_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "relatedCreatorsConnection",
      "kind": "LinkedField",
      "name": "relatedCreators",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "relatedCreatorsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RelatedCreatorType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "LinkData",
                  "kind": "LinkedField",
                  "name": "linkData",
                  "plural": false,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "SeoLink_linkData"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "browseContent",
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "browseContentModule",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/)
          ],
          "type": "ContentModuleRegular",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespContentModuleSelector_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SaveSearchButton_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
})();

(node as any).hash = "f444b80b844c9c230bc4a3e154b4cd7d";

export default node;
